<template>
  <cargo-user-select
    :default-value="value"
    v-bind="$attrs"
    v-on="new$listeners"
    @change="onChange"
  />
</template>

<script>
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'

export default {
  name: 'CargoUserSelectStandard',
  components: {
    cargoUserSelect
  },
  props: {
    value: { type: [String, Number], required: true }
  },
  computed: {
    new$listeners() {
      const result = { ...this.$listeners }
      delete result.change
      return result
    }
  },
  methods: {
    onChange(data) {
      let newValue = data instanceof Object ? data.value : data
      if (newValue === '') {
        if (typeof this.value === 'number') {
          newValue = 0
        }
      }
      if (newValue !== this.value) {
        this.$emit('input', newValue)
        this.$emit('change', newValue)
      }
    }
  }
}
</script>
